import { Http } from '@/lib/http';

export class AccountClassificationService extends Http {
  constructor() {
    super();
  }

  async fetchAccountClassifications() {
    return await this.httpClient().get(`onboarder/settings/account-types`);
  }

  async updateAccountClassification(id, data) {
    return await this.httpClient().patch(
      `onboarder/settings/account-types/${id}`,
      data
    );
  }

  async createAccountClassification() {
    return await this.httpClient().post(`onboarder/settings/account-types`);
  }

  async fetchAccountClasses() {
    return await this.httpClient().get(`onboarder/settings/account-classes`);
  }

  async updateAccountClass(id, data) {
    return await this.httpClient().patch(
      `onboarder/settings/account-classes/${id}`,
      data
    );
  }

  async createAccountClass() {
    return await this.httpClient().post(`onboarder/settings/account-classes`);
  }

  async createPersonClasses() {
    return await this.httpClient().post(`onboarder/settings/person-classes`);
  }

  async getPersonClasses() {
    return await this.httpClient().get(`onboarder/settings/person-classes`);
  }

  async updatePersonClasses(ID, payload) {
    return await this.httpClient().patch(
      `onboarder/settings/person-classes/${ID}`,
      payload
    );
  }
}
